__turbopack_context__.v({
  "colorBlue": "SolutionsShowcaseSection-module-scss-module__Sh12GW__colorBlue",
  "colorGreen": "SolutionsShowcaseSection-module-scss-module__Sh12GW__colorGreen",
  "colorOrange": "SolutionsShowcaseSection-module-scss-module__Sh12GW__colorOrange",
  "colorPink": "SolutionsShowcaseSection-module-scss-module__Sh12GW__colorPink",
  "container": "SolutionsShowcaseSection-module-scss-module__Sh12GW__container",
  "containerWrapper": "SolutionsShowcaseSection-module-scss-module__Sh12GW__containerWrapper",
  "solutionsList": "SolutionsShowcaseSection-module-scss-module__Sh12GW__solutionsList",
  "stickyContainer": "SolutionsShowcaseSection-module-scss-module__Sh12GW__stickyContainer",
});
